<template>
  <v-layout
    wrap
    class="mb-4"
  >
    <weekdays-picker
      :weekdays.sync="modelWeekDays"
      :title="$t('chooseWeekdays')"
      style="max-width: 300px"
      show-workdays-button
      show-saturday-button
    />
    <v-layout
      column
      :class="{'mt-4': $vuetify.breakpoint.xs}"
    >
      <div>
        <v-label>{{ $t('setClosingtimeMinutesBeforeClosing') }}</v-label>
      </div>
      <v-text-field
        v-model="modelMinutesBeforeClosing"
        type="number"
        :title="$t('setClosingtimeMinutesBeforeClosing')"
        data-cy="closingtime-minutes-textfield"
        :rules="[rules.minutesBeforeClosingMin, rules.minutesBeforeClosingMax]"
        class="pt-2"
        style="max-width: 60px"
      />
    </v-layout>
  </v-layout>
</template>

<script>
import WeekdaysPicker from '@/components/WeekdaysPicker';

export default {
  components: {WeekdaysPicker},
  props: {
    weekDays: {
      type: Array[Number],
      required: true,
    },
    minutesBeforeClosing: {
      type: [String, Number],
      required: true,
    },
    /**
     * Can be used with .sync to communicate form validation status back to parent.
     */
    formIsValid: {
      type: Boolean,
      default: true,
    },
  },
  computed: {
    minutesBeforeClosingMinimum() {
      return 1;
    },
    minutesBeforeClosingMaxmimum() {
      return 60;
    },
    rules() {
      const valueMin = this.minutesBeforeClosingMinimum;
      const valueMax = this.minutesBeforeClosingMaxmimum;
      const tooLow = this.$t('invalidNumberTooLow');
      const tooHigh = this.$t('invalidNumberTooHigh');
      return {
        minutesBeforeClosingMin: (v) => v >= valueMin || tooLow,
        minutesBeforeClosingMax: (v) => v <= valueMax || tooHigh,
      };
    },
    /**
     * Wrap props so that we can sync updates upwards properly.
     */
    modelWeekDays: {
      get() {
        return this.weekDays;
      },
      set(value) {
        this.$emit('update:weekDays', value);
      },
    },
    modelMinutesBeforeClosing: {
      get() {
        return this.minutesBeforeClosing;
      },
      set(value) {
        this.$emit('update:minutesBeforeClosing', value);
      },
    },
    modelFormIsValid() {
      return (
        this.weekDays.length > 0 &&
        this.minutesBeforeClosing >= this.minutesBeforeClosingMinimum &&
        this.minutesBeforeClosing <= this.minutesBeforeClosingMaxmimum
      );
    },
  },
  watch: {
    modelFormIsValid: function (valid) {
      this.$emit('update:formIsValid', valid);
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/components/ClosingtimeControls.vue